<template>
  <div class="coupon_list_page">
    <div class="banner">
      <img src="../../assets/img/couponBanner.png" alt="" />
    </div>
    <div class="coupon_content" v-if="couponList.length > 0">
      <el-card
        v-for="(item, index) of couponList"
        :key="index"
        class="card_box"
      >
        <div slot="header" class="clearfix">
          <span class="title">{{ item.couponPrice }}</span>
          <el-button
            v-if="!item.userStatus"
            style="float: right; padding: 3px 0; color: #00a0e9"
            type="text"
            @click="toReceive(item)"
            >领取</el-button
          >
          <el-button
            style="float: right; padding: 3px 0; color: #9b9b9b"
            type="text"
            disabled
            v-else
            >已领取</el-button
          >
        </div>
        <div class="subtitle">
          使用规则：
          {{ item.couponLimitprice }}
        </div>
      </el-card>
    </div>
    <div class="noData" v-else>
      <span class="tips">~暂时没有可以领取的优惠券哦~</span>
    </div>
  </div>
</template>

<script>
import { couponListApi, getCouponApi } from "../../api/index";
export default {
  data() {
    return {
      couponList: [],
      loading: false,
    };
  },
  created() {},
  activated() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      couponListApi()
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData.couponList || [];
            this.couponList = result;
          } else {
            this.couponList = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toReceive(data) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      getCouponApi({
        couponId: data.couponId
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("已成功领取优惠券，快去使用吧")
          } else {
            this.$message.warning(res.errorMessage)
          }
        })
        .finally(() => {
          this.loading = false;
          this.getData();
        });
    }
  },
};
</script>

<style lang="less">
.coupon_list_page {
  width: 100%;
  padding: 10px 10px 10px 20px;
  box-sizing: border-box;
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #00a0e9;
  }
  .subtitle {
    font-size: 13px;
    color: #333;
  }
  .banner {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .card_box {
    margin-bottom: 12px;
  }
  .noData {
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tips {
      font-size: 13px;
      color: #333;
    }
  }
}
</style>